/** Safari and Firefox can't send audio to a chosen output. */
export const canChooseOutput = (): boolean =>
  typeof HTMLMediaElement !== 'undefined' && 'setSinkId' in HTMLMediaElement.prototype

type SinkTarget = { setSinkId?: (sinkId: string) => Promise<void> }

/** Send an element's or a context's sound to `outputId`; the default on null or a vanished device. */
export const routeOutput = (target: object, outputId: string | null): void => {
  const sink = target as SinkTarget
  void sink.setSinkId?.(outputId ?? '').catch(() => sink.setSinkId?.('').catch(() => {}))
}
